(function() {
  const COLLECTION_SELECTOR = '.template-collection, .template-search';
  const BUTTON_SELECTOR     = '[data-action="change-layout"]';
  const STORAGE_KEY         = 'collection_layout_preference';

  // Apply a given layout mode to the collection container and buttons
  function applyLayout(layoutMode) {
    const productColl  = document.querySelector(COLLECTION_SELECTOR);
    const layoutButtons = document.querySelectorAll(BUTTON_SELECTOR);
    if (!productColl || !layoutButtons.length) return;

    // Toggle classes
    productColl.classList.toggle('collection--grid-view', layoutMode === 'layout-grid');
    productColl.classList.toggle('collection--list-view', layoutMode === 'list');

    // Toggle active button state
    layoutButtons.forEach(btn => {
      btn.classList.toggle('is-active', btn.dataset.layoutMode === layoutMode);
      const gridElement = document.querySelector('.template-collection .grid, .template-search .grid');
      if (gridElement) gridElement.classList.remove('opacity0');
    });
  }

  // On click of any layout-button (delegated from document)
  document.addEventListener('click', function(e) {
    const btn = e.target.closest(BUTTON_SELECTOR);
    if (!btn) return;

    const mode = btn.dataset.layoutMode;
    applyLayout(mode);
    localStorage.setItem(STORAGE_KEY, mode);
  });

  // On initial load or whenever you re-inject the collection via AJAX
  function initializeLayoutSwitcher() {
    // remove any "flash" effect if you have one
    const mainCollection = document.querySelector('.template-collection .grid, .template-search .grid');
    if (mainCollection) mainCollection.classList.remove('opacity0');
    
    // Look for saved preference or use section.settings.view_as as default
    const saved = localStorage.getItem(STORAGE_KEY);
    
    if (saved) {
      // Apply saved layout from localStorage
      applyLayout(saved);
    } else {
      // No localStorage found - use section.settings.view_as from container
      const container = document.querySelector('.container--large[data-view]');
      if (container) {
        // Add the data-view value to template-collection as a class
        const collectionTemplate = document.querySelector(COLLECTION_SELECTOR);
        if (collectionTemplate) {
          collectionTemplate.classList.add(container.dataset.view);
        }
        // Also apply it as a layout if it matches our layout options
        if (container.dataset.view === 'layout-grid' || container.dataset.view === 'list') {
          applyLayout(container.dataset.view);
        }
      }
    }
  }

  // DOM ready
  document.addEventListener('DOMContentLoaded', initializeLayoutSwitcher);
})();
const gridElement = document.querySelector('.template-collection .grid, .template-search .grid');
if (gridElement) gridElement.classList.remove('opacity0');
